// Actions (动作; "emotes" in the code and on the wire): 1 挥手 … 7 爱心, 8 睡觉, 16 偷笑 (捂嘴偷笑; no key). Keys 1-8 (not while typing), the 动作
// menu in the bottom bar, or a long press on the map (touch). The office passes one to whoever hears you
// (src/office/emote.ts) and keeps it on your otter for its time (EMOTE_MS; 睡觉: SLEEP_ACTION_MS) so late arrivals see
// it too; moving ends it. Each one is a few sheet frames (assets/otters/otters.py, looks.js ANIM.em*: deck/pose.js
// plays them) plus an icon popping over the head (emote-icons.png, deck/entities.js).
// 睡觉 lies down with the z z of the idle sleep (deck/pose.js, the 3D otters' `sleep`) until the otter moves, chats,
// speaks or does another action. A page from before 睡觉 doesn't know id 8 and shows nothing (emoteById: null).
// 9-15 (`act`: 敲电脑, 玩手机, 伸懒腰, 歪头 (was 蹭蹭: that's the two-person one now), 蹦跶 (was 转圈圈: that's the
// two-person one now), 炸毛, 比心, after the 月薪喵 stickers) were the cats' own; every body has them now (artin:
// 「为啥那些只有猫有的动作，其实感觉水獭也可以啊」). No keys; they play in the direction the otter faces (16 ways,
// otter3d.js ANIMS cat*), from the body's act sheets (looks.js actReady: loaded when one first plays). The office passes
// them on like the rest; a page from before them ignores the id, a page from before otters had them shows an otter's
// as the icon only, and so do the classic otters.
import { t, onLang } from '/i18n.js';
export const EMOTE_MS = 3000; // src/office/emote.ts EMOTE_MS
export const SLEEP_ACTION_MS = 30 * 60e3; // src/office/emote.ts SLEEP_MS
export const ICONS = new URL('./emote-icons.png', import.meta.url).pathname; // 16x16 icons in EMOTES order, then the little floating heart, then 睡觉's
export const HEART_ICON = 7, ICON_CELLS = 17; // assets/otters/otters.py EMOTE_CELLS
/** id = the key and the wire's `emote`; name = its catalog key (public/i18n.js); anim = looks.js ANIM name; seq: [frame of anim, ms] looped while it plays. */
export const EMOTES = [
  { id: 1, name: 'emote.wave', anim: 'emWave', seq: [[0, 180], [1, 180], [2, 180], [1, 180]] },
  { id: 2, name: 'emote.facepalm', anim: 'emFacepalm', seq: [[0, 600], [1, 900], [2, 500], [1, 1000]] },
  { id: 3, name: 'emote.broke', anim: 'emBroke', seq: [[0, 650], [2, 550], [1, 160], [3, 160], [1, 160], [3, 160], [1, 160], [3, 160], [1, 160], [3, 160], [1, 420]] },
  { id: 4, name: 'emote.hug', anim: 'emHug', seq: [[0, 350], [1, 450], [0, 300], [2, 450]] },
  { id: 5, name: 'emote.raise', anim: 'emRaise', seq: [[0, 380], [1, 380]] },
  { id: 6, name: 'emote.clap', anim: 'emClap', seq: [[0, 150], [1, 150]] },
  { id: 7, name: 'emote.heart', anim: 'emHeart', seq: [[0, 330], [1, 330]] },
  // no frames of its own: deck/pose.js shows the sleep; the icon pops up for EMOTE_MS, then the z z say it
  { id: 8, name: 'emote.sleep', sleep: true, icon: 8, ms: SLEEP_ACTION_MS },
  // on the act sheets (icons 9-15; were the cats' own)
  { id: 9, name: 'emote.type', act: true, icon: 9, anim: 'catType', seq: [[0, 140], [1, 140], [2, 140], [3, 140]] },
  { id: 10, name: 'emote.phone', act: true, icon: 10, anim: 'catPhone', seq: [[0, 700], [1, 220], [0, 220], [1, 220], [0, 600], [2, 900]] },
  { id: 11, name: 'emote.stretch', act: true, icon: 11, anim: 'catStretch', seq: [[0, 500], [1, 900], [2, 700], [1, 500]] },
  { id: 12, name: 'emote.tilt', act: true, icon: 12, anim: 'catRub', seq: [[0, 300], [1, 250], [2, 300], [3, 250]] },
  { id: 13, name: 'emote.hop', act: true, icon: 13, anim: 'catSpin', seq: [[0, 120], [1, 120], [2, 120], [3, 120]] },
  { id: 14, name: 'emote.bristle', act: true, icon: 14, anim: 'catAngry', seq: [[0, 160], [1, 160]] },
  { id: 15, name: 'emote.fingerHeart', act: true, icon: 15, anim: 'catHeart', seq: [[0, 350], [1, 300], [2, 900], [1, 250], [2, 900]] },
  // every body's again (icon 16): 捂嘴偷笑, after artin's sticker; no key (1-8 are taken)
  { id: 16, name: 'emote.giggle', icon: 16, anim: 'emGiggle', seq: [[0, 250], [1, 250], [2, 250], [3, 250]] },
];
/** Which cell of ICONS an action's icon is. */
export const iconOf = (def) => def.icon ?? def.id - 1;
export const emoteById = (id) => EMOTES[id - 1] ?? null;

/** The office said this otter emotes (`ms` left; emote 0: it stopped). */
export function setEmote(p, emote, ms, now = performance.now()) {
  const def = emote ? emoteById(emote) : null;
  p.emote = def && ms > 0 ? { id: emote, at: now, until: now + Math.min(ms, def.ms ?? EMOTE_MS), x: p.x, y: p.y } : null;
}

/**
 * The emote an otter is playing now, or null: it ends when its time is up or the otter moves (walks, swims, or is
 * put somewhere else); 睡觉 also when it is woken (chat or speech: p._awakeAt, after it lay down).
 * @returns {{id, def, t}|null} t: ms since it started
 */
export function emoteNow(p, now = performance.now()) {
  const e = p.emote;
  if (!e) return null;
  const def = emoteById(e.id);
  if (now >= e.until || p.moving || Math.hypot(p.x - e.x, p.y - e.y) > 0.3 || (def?.sleep && (p._awakeAt ?? -1e9) > e.at)) { p.emote = null; return null; }
  return { id: e.id, def, t: now - e.at };
}

/** Which frame of its animation an emote shows t ms in (null: it has none). */
export function emoteStep(def, t) {
  if (!def.seq) return null;
  const total = def.seq.reduce((s, [, ms]) => s + ms, 0);
  let x = t % total;
  for (const [f, ms] of def.seq) { if (x < ms) return f; x -= ms; }
  return def.seq[0][0];
}

/**
 * The 动作 menu: a row of the actions over the bottom bar. Opened by the button or a long press on the map.
 * @param {object} o
 * @param {HTMLButtonElement} o.button
 * @param {(id: number) => void} o.play
 * @returns {{open(), close(), toggle(), shown(): boolean}}
 */
export function emoteMenu({ button, play }) {
  const st = document.createElement('style');
  st.textContent = `#emoteMenu{position:fixed;left:50%;bottom:calc(var(--barh, calc(68px + var(--sb, 0px))) + 8px);transform:translateX(-50%);display:none;gap:4px;background:#fff8e7;border:3px solid #1b1410;border-radius:16px;padding:6px;z-index:5;max-width:calc(100vw - 24px);flex-wrap:wrap;justify-content:center}
  #emoteMenu button{font:inherit;font-size:12px;border:2px solid #1b1410;border-radius:12px;background:#fff;cursor:pointer;padding:4px 6px 3px;display:flex;flex-direction:column;align-items:center;gap:1px;min-width:52px}
  #emoteMenu button:hover{background:#FDD03B} #emoteMenu i{display:block;width:32px;height:32px;background:url(${ICONS}) 0 0/${32 * ICON_CELLS}px 32px no-repeat;image-rendering:pixelated}
  #emoteMenu kbd{font:10px system-ui;color:#888}`;
  document.head.appendChild(st);
  const box = document.createElement('div'); box.id = 'emoteMenu';
  for (const e of EMOTES) {
    const b = document.createElement('button'); b.dataset.emote = e.id;
    const i = document.createElement('i'); i.style.backgroundPositionX = `${-32 * iconOf(e)}px`;
    const n = document.createElement('span');
    const k = document.createElement('kbd');
    b.append(i, n, k); box.append(b);
  }
  // the words: drawn now and again on a language change (public/i18n.js)
  const words = () => box.querySelectorAll('button').forEach((b, j) => {
    const e = EMOTES[j], name = t(e.name), [, n, k] = b.children;
    b.title = e.id > 8 ? name : t(e.sleep ? 'emote.tip.sleep' : 'emote.tip.key', { name, key: e.id }); // (keys: 1-8 only)
    n.textContent = name;
    k.textContent = e.id > 8 ? '' : e.id;
  });
  words(); onLang(words);
  document.body.append(box);
  const shown = () => box.style.display !== 'none';
  const open = () => { box.style.display = 'flex'; button.classList.add('on'); };
  const close = () => { box.style.display = 'none'; button.classList.remove('on'); };
  box.onclick = (e) => { const b = e.target.closest('button'); if (b) { play(+b.dataset.emote); close(); } };
  button.onclick = () => (shown() ? close() : open());
  // a press anywhere else closes it (the long press that opened it lifts its finger on the map: not a press)
  addEventListener('pointerdown', (e) => { if (shown() && !box.contains(e.target) && e.target !== button) close(); }, true);
  addEventListener('keydown', (e) => { if (e.key === 'Escape' && shown()) { e.preventDefault(); close(); } }); // handled: 钓鱼 mode stays open
  return { open, close, toggle: () => (shown() ? close() : open()), shown };
}
